var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentDevice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-content-device") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-content-device",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#53575C",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,6.5 L19.5,19 L5,19.5 L4.5,7 L19,6.5 Z",
    id: "Rectangle",
    stroke: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,6 C9.77614237,6 10,6.22385763 10,6.5 L10,19.5 C10,19.7761424 9.77614237,20 9.5,20 C9.22385763,20 9,19.7761424 9,19.5 L9,6.5 C9,6.22385763 9.22385763,6 9.5,6 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,6 C14.7761424,6 15,6.22385763 15,6.5 L15,19.5 C15,19.7761424 14.7761424,20 14.5,20 C14.2238576,20 14,19.7761424 14,19.5 L14,6.5 C14,6.22385763 14.2238576,6 14.5,6 Z",
    id: "Rectangle",
    fill: "#53575C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentDevice);
export default __webpack_public_path__ + "static/media/ic-content-device.2f974f1047ec472ba5d9a52530dfa618.svg";
export { ForwardRef as ReactComponent };